import { render } from "./OtherContentSinglePage.vue?vue&type=template&id=a8b6ffdc"
import script from "./OtherContentSinglePage.vue?vue&type=script&lang=js"
export * from "./OtherContentSinglePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/Clients/visiontrust/vision-trust-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__